import { alertService } from 'components/Varios/alert_service';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import React, { useCallback, useState, useMemo } from 'react';
import { useTable, Column, Accessor, HeaderGroup, useGlobalFilter, usePagination, useSortBy, useRowSelect } from "react-table";
import { Container, Table, Row, Col, Label, Input, Button } from 'reactstrap'
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';

import {
    AprobarParcialmenteSolicitudCambioHorario, DirectivoAprobadorObtenerVistaPreviaFormularioCambioHorario,
    AprobarSolicitudCambioHorario,
    AprobarMasivaSolicitudPermisos,
    RechazarSolicitudCambioHorario
} from './FunctionsAprobacionSolicitudes';

import { EstadoSolicitudReplanificacionVacaciones, EstadoSolicitud, TipoFiltroSolicitudAprobar, TipoSolicitud, EstadoSolicitudPermisos, TipoSolicitudPermiso } from './TypesAprobacionSolicitudes';

import ModalRechazo from "./ModalRechazoSolicitud"
import { FormGroup } from 'react-bootstrap';
import { authenticationService } from 'services/authentication.service';


import PDFViewer from "components/Varios/PDFViewer";
import Cargando from 'components/Varios/Cargando';
import ModalCargando from 'components/Varios/ModalCargando';
import { Checkbox } from 'components/Varios/Tabla/CheckBoxTable';

import "../../../assets/scss/TablaAprobacionSolicitudesMasivas.scss";

export default function TableSolicitudesCambioHorarioAprobar({ dataprops, recargarInformacionTabla, tipoFiltroSolicitud, filtrarTiposSolicitud }) {



    const TIPO_SOLICITUDES_APROBAR_MASIVAMENTE = [TipoSolicitudPermiso.PERMISOSAM, TipoSolicitudPermiso.PERMISOSMH, TipoSolicitudPermiso.LICENCIASCD, TipoSolicitudPermiso.LICENCIASM, TipoSolicitudPermiso.LICENCIASP, TipoSolicitudPermiso.LICENCIASEFP]

    const defaultStateInformacionModalAprobarSolicitud = {
        url: "",
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        tituloModal: "Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido"
    }

    const defaultStateInformacionModalAprobarParcialmenteSolicitud = {
        tituloModal: "Aprobación Parcial Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido",
        cargando: false,
        idSolicitud: -1,
        contentBody: undefined
    }


    const defaultStateInformacionModalRechazarSolicitud = {

        cargando: false,
        idSolicitud: -1,
        contentBody: undefined,
        observacion: ""
    }

    const defaultSateModalAprobacionMasivaSolicitud = {
        cargando: false,
        listadoSolicitudesAprobar: [],
        contentBody: undefined
    }




    const [stateinformacionModalAprobarSolicitud, setstateinformacionModalAprobarSolicitud] = useState(defaultStateInformacionModalAprobarSolicitud)
    const [stateinformacionModalAprobarParcialmenteSolicitud, setstateinformacionModalAprobarParcialmenteSolicitud] = useState(defaultStateInformacionModalAprobarParcialmenteSolicitud)
    const [stateinformacionModalRechazarSolicitud, setstateinformacionModalRechazarSolicitud] = useState(defaultStateInformacionModalRechazarSolicitud)

    //Aprobacion Masiva
    const [stateModalAprobacionMasivaSolicitud, setstateModalAprobacionMasivaSolicitud] = useState(defaultSateModalAprobacionMasivaSolicitud)

    const [observacion, setobservacion] = useState("")
    const data = React.useMemo(
        () => [...dataprops], [dataprops]
    )


    async function OnClickAccionModalFormulario(idSolicitud) {
        setstateinformacionModalAprobarSolicitud({ cargando: true })
        var accionRealizada = await AprobarSolicitudCambioHorario(idSolicitud)
        setstateinformacionModalAprobarSolicitud(defaultStateInformacionModalAprobarSolicitud)
        await recargarInformacionTabla();
    }

    async function onClickAprobarSolicitud(informacionAcciones) {

        setstateinformacionModalAprobarSolicitud({ ...defaultStateInformacionModalAprobarSolicitud, cargando: true })

        var respuesta = await DirectivoAprobadorObtenerVistaPreviaFormularioCambioHorario(informacionAcciones.idSolCambioHorarioPRN);
        if (respuesta.status === 200) {

            const tituloModal = "Aprobación de Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido";

            setstateinformacionModalAprobarSolicitud({
                url: respuesta.dataResponse,
                cargando: false,
                idSolicitud: informacionAcciones.idSolCambioHorarioPRN,
                modalContent: AuxiliarGenerarHTMLBodyModalSolicitud(informacionAcciones),
                tituloModal

            })
        }
        else {
            setstateinformacionModalAprobarSolicitud(defaultStateInformacionModalAprobarSolicitud)
            alertService.error(respuesta.errorMessage ?? "No pudo obtenerse la vista Previa de Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido");
        }
    }


    function onClickAprobarParcialmenteSolicitud(informacionAcciones) {

        const contentBody = AuxiliarGenerarHTMLBodyModalSolicitud(informacionAcciones);
        const tituloModal = "Aprobación Parcial Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido"
        setstateinformacionModalAprobarParcialmenteSolicitud({
            cargando: false,
            idSolicitud: informacionAcciones.idSolCambioHorarioPRN,
            contentBody,
            tituloModal: tituloModal
        })
    }


    function onClickRechazarSolicitud(informacionAcciones) {

        const contentBody = AuxiliarGenerarHTMLBodyModalSolicitud(informacionAcciones);

        setstateinformacionModalRechazarSolicitud({
            cargando: false,
            idSolicitud: informacionAcciones.idSolCambioHorarioPRN,
            contentBody,
            observacion

        })
    }



    async function RechazarCambioHorario(idSolicitud, observacion) {
        const respuesta = await RechazarSolicitudCambioHorario(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            alertService.error(respuesta.errorMessage)
        }
        else {
            alertService.success("Se ha negado la solicitud de cambio de horario de permiso para cuidado del recién nacido");

        }
    }




    function onClickAprobacionMasiva(solicitudesAprobar) {

        const contentBody = (
            <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Fecha Solicitud</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Hora Entrada</th>
                            <th> Hora Salida</th>
                            <th> Estado</th>

                        </tr>
                    </thead>
                    <tbody>

                        {solicitudesAprobar.map((solicitudes, ind) => {
                            const informacionAcciones = solicitudes.acciones;
                            return (
                                <tr key={"trMasivoSolicVac" + ind} className="rowHistorialSolicitudVacaciones">
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(informacionAcciones.fechaDesde)}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(informacionAcciones.fechaHasta)}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.horaEntrada.split(".")[0] + ":" + informacionAcciones.horaEntrada.split(".")[1]}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.horaSalida.split(".")[0] + ":" + informacionAcciones.horaSalida.split(".")[1]}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.estadoParse}
                                        </div>

                                    </td>


                                </tr>
                            )
                        })}

                    </tbody>
                </Table>
            </>

        )

        setstateModalAprobacionMasivaSolicitud({
            cargando: false,
            listadoSolicitudesAprobar: solicitudesAprobar,
            contentBody


        })
    }



    const ModalAprobacionMasivaSolicitudVacaciones = useMemo(() => {
        return (
            <ModalConfirmacion
                show={stateModalAprobacionMasivaSolicitud.listadoSolicitudesAprobar.length > 0}
                size="lg"
                onClose={() => setstateModalAprobacionMasivaSolicitud(defaultSateModalAprobacionMasivaSolicitud)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea aprobar las siguientes solicitudes"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => AprobarMasivaSolicitudPermisos(stateModalAprobacionMasivaSolicitud.listadoSolicitudesAprobar)}
                contentModal={stateModalAprobacionMasivaSolicitud.contentBody}
                tituloModal={"Aprobación masiva solicitudes"}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                botonesAccionParteSuperior={true}

            />


        )
    }, [stateModalAprobacionMasivaSolicitud])

    function AuxiliarGenerarHTMLBodyModalSolicitud(informacionAcciones) {
        const contentBody = (
            <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Fecha Solicitud</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Hora Entrada </th>
                            <th> Hora Salida </th>
                            <th> Estado</th>


                        </tr>
                    </thead>
                    <tbody>

                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaDesde)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaHasta)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.horaEntrada.split(":")[0] + ":" + informacionAcciones.horaEntrada.split(":")[1]}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.horaSalida.split(":")[0] + ":" + informacionAcciones.horaSalida.split(":")[1]}
                                </div>
                            </td>

                            <td className="">
                                <div className="">
                                    {informacionAcciones.estadoParse}
                                </div>

                            </td>

                        </tr>

                    </tbody>
                </Table>
            </>

        )

        return contentBody;
    }



    function GenerarCellAcciones(informacionAcciones) {
        if (informacionAcciones === undefined || informacionAcciones === null) {
            return <span></span>
        }
        else if ((informacionAcciones.estadoSolicitud === EstadoSolicitudPermisos.INGRESADO || informacionAcciones.estadoSolicitud === EstadoSolicitudPermisos.REVISADOPARCIAL) && informacionAcciones.aprueba === "S") {

            const iconoAprobar = (
                <i
                    className="fa-regular fa-circle-check acciones"
                    data-toggle="tooltip" data-placement="top" title="Aprobar"

                    onClick={() => onClickAprobarSolicitud(informacionAcciones)}
                >
                </i>
            )

            const contentAccion = (
                <React.Fragment>


                    {iconoAprobar}
                    <i
                        onClick={() => onClickRechazarSolicitud(informacionAcciones)}
                        className="fa-regular fa-circle-xmark ml-2 acciones"
                        data-toggle="tooltip" data-placement="top" title="Negar"

                    ></i>

                </React.Fragment>
            )
            return contentAccion

        }
        else if (informacionAcciones.estadoSolicitud === EstadoSolicitudPermisos.INGRESADO && informacionAcciones.aprueba === "N") {
            const iconoAprobar = (
                <i
                    className="fa-regular fa-circle-check acciones"
                    onClick={() => onClickAprobarParcialmenteSolicitud(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Aprobar"

                >
                </i>
            )
            const contentAccion = (
                <React.Fragment>
                    {iconoAprobar}
                    <i onClick={() => onClickRechazarSolicitud(informacionAcciones)}
                        className="fa-regular fa-circle-xmark ml-2 acciones"
                        data-toggle="tooltip" data-placement="top" title="Negar"

                    >
                    </i>

                </React.Fragment>
            )
            return contentAccion
        }
        else {
            return <div />
        }
    }

    const column_usando = React.useMemo(
        () => [
            {
                Header: 'Fecha Solicitud',
                accessor: 'fechaSolicitud',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: 'Nombres',
                accessor: 'nombres',
            },
            {
                Header: 'Fecha Desde',
                accessor: 'fechaDesde',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: 'Fecha Hasta',
                accessor: 'fechaHasta',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: 'Hora Entrada',
                accessor: 'horaEntrada',
                Cell: ({ value }) => {
                    const [hora, minutos] = value.split(":"); // Dividir la hora y los minutos
                    return `${hora}:${minutos}`; // Devolver solo la hora y los minutos
                }
            },
            {
                Header: 'Hora Salida',
                accessor: 'horaSalida',
                Cell: ({ value }) => {
                    const [hora, minutos] = value.split(":"); // Dividir la hora y los minutos
                    return `${hora}:${minutos}`; // Devolver solo la hora y los minutos
                }
            },
            {
                Header: 'Estado',
                accessor: 'estadoParse',
            },
            {
                Header: 'Observaciones',
                accessor: 'observacion',
            },
            {
                Header: "Acciones",
                accessor: 'acciones',
                Cell: ({ value }) => GenerarCellAcciones(value)
            }
        ], [dataprops]
    )


    function ShowCheckBoxCondition(dataRow) {
        return dataRow ;
    }

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        selectedFlatRows,
        prepareRow,
        state,
        setGlobalFilter,
        getToggleHideAllColumnsProps,
        getToggleAllPageRowsSelectedProps,
        toggleRowSelected

    } = useTable(
        {
            columns: column_usando,
            data
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => {
                return [
                    {
                        id: 'selection',
                        Header: ({ getToggleAllPageRowsSelectedProps }) => (
                            <Checkbox
                                isHeader={true}
                                {...getToggleAllPageRowsSelectedProps()}
                            />
                        ),
                        Cell: ({ row }) => (
                            <Checkbox
                                condition={ShowCheckBoxCondition(row.values)}
                                {...row.getToggleRowSelectedProps()}

                            />
                        )

                    },
                    ...columns
                ]
            })
        }
    )

    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = data.length;

    const columnasStyles = (cell) => {
        return ([
            {
                HeaderName: "Nombres",
                StyleHeader: {
                    textAlign: "left"
                }
            },
            {
                HeaderName: "Estado",
                StyleHeader: {
                    textAlign: "center"
                }
            },
            {
                HeaderName: "Fecha Solicitud",
                StyleHeader: {
                    textAlign: "center"
                }
            },
            {
                HeaderName: "Fecha Desde",
                StyleHeader: {
                    textAlign: "center"
                }
            },
            {
                HeaderName: "Fecha Hasta",
                StyleHeader: {
                    textAlign: "center"
                }
            },
            {
                HeaderName: "Hora Entrada",
                StyleHeader: {
                    textAlign: "center"
                }
            },
            {
                HeaderName: "Hora Salida",
                StyleHeader: {
                    textAlign: "center"
                }
            },
            {
                HeaderName: "Observaciones",
                StyleHeader: {
                    textAlign: "justify",
                    width: "200px"

                }
            }
        ])
    }

    const ButtonAprobacionMasiva = useMemo(() => {

        const nombreBotonAprobarMasivo = "Aprobar todas las solicitudes seleccionadas";
        if (selectedFlatRows.length === 1) {
            var filaSeleccionada = selectedFlatRows[0].original;
            if (filaSeleccionada.aprueba === "S") {
                return <Button className="fleft" onClick={() => onClickAprobarSolicitud(filaSeleccionada.acciones)} >Aprobar Solicitud </Button>
            }
            else {
                return <Button className="fleft" onClick={() => onClickAprobarParcialmenteSolicitud(filaSeleccionada.acciones)} >Aprobar Solicitud </Button>
            }
        }

        else if (selectedFlatRows.length > 1) {
            var filasSeleccionadas = selectedFlatRows;
            var filasMapeadas = [];
            filasSeleccionadas.forEach(element => {
                if (TIPO_SOLICITUDES_APROBAR_MASIVAMENTE.includes(element.original.idTipoPermiso)) {
                    filasMapeadas.push(element.original)
                }
            });
            if (filasMapeadas.length > 0) {
                return (<Button className="fleft" onClick={() => onClickAprobacionMasiva(filasMapeadas)} >{nombreBotonAprobarMasivo} </Button>)
            }
            else if (filasMapeadas.length <= 0) {
                return (<Button className="fleft" disabled >{nombreBotonAprobarMasivo} </Button>)
            }
        }
        else {
            return <Button className="fleft" disabled>{nombreBotonAprobarMasivo}</Button>
        }

    }, [selectedFlatRows])


    return (
        <React.Fragment>
            <Row>
                <Col xl={12}>
                    <GlobalFilterTable
                        filter={globalFilter}
                        setFilter={setGlobalFilter}
                    />
                </Col>
            </Row>
            <Row className={"mb-3 rowBotonFiltroAprobacionMasivaSolicitudes"}>


                <Col xl={2}>
                    <div className='containerBotonAprobMasivaSolicitudes'>
                        {ButtonAprobacionMasiva}
                    </div>
                </Col>
            </Row>

            <Row className={"mb-2"}>

                <Col>
                    <p>{tipoFiltroSolicitud === TipoFiltroSolicitudAprobar.CAMBIOHORARIO ? "Se estan mostrando las solicitudes de cambio de horario de permiso para cuidado del recién nacido" : ""}</p>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
                        <thead style={{}}>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            style={{ width: column.Header === "Observaciones" ? "300px" : "auto" }}
                                            className='clickable'
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>

                                        {row.cells.map(cell => {
                                            return getTdTableStyles(cell, { border: 'solid 1px black' }, columnasStyles(cell))

                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    <ComponentePaginacionTabla
                        page={page}
                        sizerows={sizerows}
                        canNextPage={canNextPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        previousPage={previousPage}
                        setPageSize={setPageSize}

                    />
                </Col>
            </Row>



            <ModalVistaPreviaDocumentosAccion
                show={stateinformacionModalAprobarSolicitud.url !== "" || stateinformacionModalAprobarSolicitud.cargando}
                accionOnAccept={true}
                cargandoDatos={stateinformacionModalAprobarSolicitud.cargando}
                onClose={() => setstateinformacionModalAprobarSolicitud(defaultStateInformacionModalAprobarSolicitud)}
                size="xl"
                tituloModal={stateinformacionModalAprobarSolicitud.tituloModal}
                urlArchivo={stateinformacionModalAprobarSolicitud.url}
                asyncAccion={() => OnClickAccionModalFormulario(stateinformacionModalAprobarSolicitud.idSolicitud)}
                nombreBotonAccion={"Aprobar"}
                disabledbuttonCondition={stateinformacionModalAprobarSolicitud.cargando}
                modalContent={undefined}
                asyncClose={true}

            />

            {/* Aprobacion Parcial de permisos */}
            <ModalConfirmacion
                show={stateinformacionModalAprobarParcialmenteSolicitud.idSolicitud > 0 || stateinformacionModalAprobarParcialmenteSolicitud.cargando}
                size="lg"
                onClose={() => setstateinformacionModalAprobarParcialmenteSolicitud(defaultStateInformacionModalAprobarParcialmenteSolicitud)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea aprobar la solicitud de cambio de horario?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => AprobarParcialmenteSolicitudCambioHorario(stateinformacionModalAprobarParcialmenteSolicitud.idSolicitud)}
                contentModal={stateinformacionModalAprobarParcialmenteSolicitud.contentBody}
                tituloModal={stateinformacionModalAprobarParcialmenteSolicitud.tituloModal}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                classNameAllModal={""}


            />

            <ModalRechazo
                show={stateinformacionModalRechazarSolicitud.idSolicitud > 0 || stateinformacionModalRechazarSolicitud.cargando}
                size="lg"
                onClose={() => setstateinformacionModalRechazarSolicitud(defaultStateInformacionModalRechazarSolicitud)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar la solicitud de cambio de horario?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => RechazarCambioHorario(stateinformacionModalRechazarSolicitud.idSolicitud, { Observacion: observacion })}
                contentModal={stateinformacionModalRechazarSolicitud.contentBody}
                tituloModal={"Negar Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido"}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                labelObservacion={"Indique el motivo de negación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}

            />

            {ModalAprobacionMasivaSolicitudVacaciones}

        </React.Fragment>
    )


}
